// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media only screen and (max-width: 1000px)
{
    .colsm{
        /* width: auto;
        height: auto;
        display: block; */
    /* min-width: 0; */
flex-basis: 0;
}
    .btn-row-resp{
        /* display: block; */
        /* flex-direction: column;
        width: 200px;
        height: auto;
        align-items: center;
        justify-content: center; */
        /* margin-left: 10%;
        margin-top: 5em; */
    }
    .benefit-detail-background-resp{
        height: 100%;
    }
    .benefit-resp2{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 10vh;
        width:90%;
        float: right;
    } 
    .resp-text{
        left: 10vh;
    }
    /* .imgbene-resp{
        width: 90%; 
    display: inline-flex;
    } */
    .benefit-resp{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width:90%;
        float: right;
    }
    .arrow-resp{
        margin-left: 0vh;
    }
    .respon{
        /* flex-direction: column;
        align-items: center;
        justify-content: center; */

    }
    .section
    {
        flex-direction: column;
    }
    .course-structure{
        flex-direction: column;
    }
     .MathPortalBackground{
        height: 1600px;
     }
    .modules{
        display: flex;
        flex-direction: column;
        
    }
    .smallbox{
        /* display: flex;
        flex-direction: column; */
        margin-top: 5vh;
        /* width: auto;
        height: auto; */
        

    }
    .largebox{
        
        display: flex;
        flex-direction: column;
        margin-top: 15vh;
        width: auto;
        height: auto;
    }
    .section-left
    {
        flex-direction: column;
    }
    .Text-small
    {
        text-align: center;
        position: relative;
    }
    
    .Text-big
    {
        text-align: center;
    }
      
  /* Change the width of the three columns to 100%
  (to stack horizontally on small screens) */

    .columns {
      width: 100%;
    }
    
}

`, "",{"version":3,"sources":["webpack://./src/MyComponents/MathPortal/MathResponsive.css"],"names":[],"mappings":";AACA;;IAEI;QACI;;yBAEiB;IACrB,kBAAkB;AACtB,aAAa;AACb;IACI;QACI,oBAAoB;QACpB;;;;kCAI0B;QAC1B;0BACkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,SAAS;QACT,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;;;OAGG;IACH;QACI,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI;;kCAE0B;;IAE9B;IACA;;QAEI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;KACC;QACG,cAAc;KACjB;IACD;QACI,aAAa;QACb,sBAAsB;;IAE1B;IACA;QACI;iCACyB;QACzB,eAAe;QACf;uBACe;;;IAGnB;IACA;;QAEI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;IACA;;QAEI,sBAAsB;IAC1B;IACA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;IACtB;;EAEF;4CAC0C;;IAExC;MACE,WAAW;IACb;;AAEJ","sourcesContent":["\n@media only screen and (max-width: 1000px)\n{\n    .colsm{\n        /* width: auto;\n        height: auto;\n        display: block; */\n    /* min-width: 0; */\nflex-basis: 0;\n}\n    .btn-row-resp{\n        /* display: block; */\n        /* flex-direction: column;\n        width: 200px;\n        height: auto;\n        align-items: center;\n        justify-content: center; */\n        /* margin-left: 10%;\n        margin-top: 5em; */\n    }\n    .benefit-detail-background-resp{\n        height: 100%;\n    }\n    .benefit-resp2{\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-left: 10vh;\n        width:90%;\n        float: right;\n    } \n    .resp-text{\n        left: 10vh;\n    }\n    /* .imgbene-resp{\n        width: 90%; \n    display: inline-flex;\n    } */\n    .benefit-resp{\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width:90%;\n        float: right;\n    }\n    .arrow-resp{\n        margin-left: 0vh;\n    }\n    .respon{\n        /* flex-direction: column;\n        align-items: center;\n        justify-content: center; */\n\n    }\n    .section\n    {\n        flex-direction: column;\n    }\n    .course-structure{\n        flex-direction: column;\n    }\n     .MathPortalBackground{\n        height: 1600px;\n     }\n    .modules{\n        display: flex;\n        flex-direction: column;\n        \n    }\n    .smallbox{\n        /* display: flex;\n        flex-direction: column; */\n        margin-top: 5vh;\n        /* width: auto;\n        height: auto; */\n        \n\n    }\n    .largebox{\n        \n        display: flex;\n        flex-direction: column;\n        margin-top: 15vh;\n        width: auto;\n        height: auto;\n    }\n    .section-left\n    {\n        flex-direction: column;\n    }\n    .Text-small\n    {\n        text-align: center;\n        position: relative;\n    }\n    \n    .Text-big\n    {\n        text-align: center;\n    }\n      \n  /* Change the width of the three columns to 100%\n  (to stack horizontally on small screens) */\n\n    .columns {\n      width: 100%;\n    }\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
